module.exports = __webpack_public_path__ + "img/pandeaming.c06c538b.gif";